import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function ImagesListErrorState({ title, description }: { title: string; description: string }) {
  return (
    <Stack direction="column" alignItems="center" justifyContent="center" height="100%" gap={0.25}>
      <ErrorOutlineRounded sx={{ fontSize: '5rem', paddingBottom: '1rem', color: 'grey.500' }} />
      <Typography color="grey.500" variant="h6" fontWeight={600}>
        {title}
      </Typography>
      <Typography color="grey.500" variant="body1">
        {description}
      </Typography>
    </Stack>
  );
}
